import { useEffect, useRef, useState } from 'react'
import styles from './CriteriaComment.module.scss'
import { CommentBox } from './CommentBox'
import { useRemoteAudit, useUpdateCriteriaCommentMutation } from '../../api/audits'
import { useDebouncedCallback } from 'use-debounce'

export const CriteriaComment = ({ className, auditId, criteriaId }) => {
  const { audit } = useRemoteAudit(auditId)
  const criteriaResponse = audit.responses?.find((r) => r.criteriaId === criteriaId)
  const initialComment = criteriaResponse?.comment || ''

  const [visible, setVisible] = useState(!!initialComment)

  const { updateCriteriaComment, isMutating } = useUpdateCriteriaCommentMutation({ auditId, criteriaId })

  const handleChange = useDebouncedCallback((newComment) => {
    updateCriteriaComment(newComment)
  }, 500)

  if (!visible)
    return (
      <div className={className}>
        <ShowCommentBoxButton onClick={() => setVisible(true)} />
      </div>
    )

  return (
    <div className={className}>
      <CommentBox comment={initialComment} onChange={handleChange} placeholder='Please provide any other comments on the quality of this section' />
      <div className={styles.footer}>
        <RemoveCommentButton auditId={auditId} criteriaId={criteriaId} onClick={() => setVisible(false)} />
        <AutoSaveStatus isMutating={isMutating} />
      </div>
    </div>
  )
}

const RemoveCommentButton = ({ onClick, ...props }) => {
  const { updateCriteriaComment, isMutating } = useUpdateCriteriaCommentMutation(props)

  const handleClick = async () => {
    onClick()
    await updateCriteriaComment(null)
  }

  return (
    <CommentButton disabled={isMutating} onClick={handleClick}>
      Remove this comment
    </CommentButton>
  )
}

const ShowCommentBoxButton = ({ onClick }) => <CommentButton onClick={onClick}>+ Add additional comments on this theme</CommentButton>

const CommentButton = (props) => <button className={styles['comment-button']} {...props} />

// TODO: Reuse?

const AutoSaveStatus = ({ isMutating, savingText = 'Saving...', savedText = 'Saved', savedDuration = 2000 }) => {
  const SAVING_STATE = 'saving'
  const SAVED_STATE = 'saved'
  const INACTIVE_STATE = null

  const [status, setStatus] = useState(INACTIVE_STATE)
  const timeoutRef = useRef(null)

  useEffect(() => {
    if (isMutating) {
      setStatus(SAVING_STATE)
      if (timeoutRef.current) clearTimeout(timeoutRef.current)
    } else if (status === SAVING_STATE) {
      setStatus(SAVED_STATE)
      timeoutRef.current = setTimeout(() => setStatus(INACTIVE_STATE), savedDuration)
    }
  }, [isMutating, status, savedDuration])

  useEffect(() => {
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current)
    }
  }, [])

  if (status === SAVING_STATE) return <>{savingText}</>
  if (status === SAVED_STATE) return <>{savedText}</>

  return null
}
